/**
 * Get unique values from array (simple values: Number, String)
 *
 * Usage:
 *  const a = ['a', 1, 'a', 2, '1'];
 *  const unique = a.filter(onlyUnique);
 *  ['a', 1, 2, '1']
 */
export const getUniqueFromArray = (value, index, self) => {
  return self.indexOf(value) === index
}
